/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Creatorcode_Body1Inputs */

const id_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menggunakan kode kreator kami membantu mendukung pengembangan egdata.app dan fitur-fiturnya. Ini tidak memengaruhi harga yang Anda bayar.`)
};

const ms_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menggunakan kod pencipta kami membantu menyokong pembangunan egdata.app dan ciri-cirinya. Ia tidak menjejaskan harga yang anda bayar.`)
};

const da_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At bruge vores creator-kode hjælper med at støtte udviklingen af egdata.app og dets funktioner. Det påvirker ikke den pris du betaler.`)
};

const de_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Verwendung unseres Creator-Codes unterstützt die Entwicklung von egdata.app und seiner Funktionen. Er hat keinen Einfluss auf den von Ihnen gezahlten Preis.`)
};

const en_us2_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Using our creator code helps support the development of egdata.app and its features. It doesn't affect the price you pay.`)
};

const es_es2_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar nuestro código de creador ayuda a apoyar el desarrollo de egdata.app y sus funciones. No afecta al precio que pagas.`)
};

const es_mx2_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar nuestro código de creador ayuda a apoyar el desarrollo de egdata.app y sus funciones. No afecta el precio que pagas.`)
};

const fil_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang paggamit ng aming creator code ay tumutulong suportahan ang pag-develop ng egdata.app at mga feature nito. Hindi ito nakakaapekto sa presyong iyong binabayaran.`)
};

const fr_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser notre code créateur aide à soutenir le développement d'egdata.app et de ses fonctionnalités. Cela n'affecte pas le prix que vous payez.`)
};

const it_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usare il nostro codice creatore aiuta a supportare lo sviluppo di egdata.app e delle sue funzionalità. Non influisce sul prezzo che paghi.`)
};

const hu_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kreator kódunk használata segíti az egdata.app és funkcióinak fejlesztését. Nem befolyásolja a fizetendő árat.`)
};

const nl_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gebruik van onze creatorcode helpt de ontwikkeling van egdata.app en zijn functies te ondersteunen. Het heeft geen invloed op de prijs die je betaalt.`)
};

const no_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Å bruke skaperkoden vår hjelper til med å støtte utviklingen av egdata.app og dens funksjoner. Det påvirker ikke prisen du betaler.`)
};

const pl_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Używanie naszego kodu twórcy pomaga wspierać rozwój egdata.app i jego funkcji. Nie wpływa to na cenę, którą płacisz.`)
};

const pt_br2_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar nosso código de criador ajuda a apoiar o desenvolvimento de egdata.app e seus recursos. Isso não afeta o preço que você paga.`)
};

const pt_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar o nosso código de criador ajuda a apoiar o desenvolvimento do egdata.app e as suas funcionalidades. Não afeta o preço que paga.`)
};

const ro_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folosind codul nostru de creator ajuți la susținerea dezvoltării egdata.app și a funcțiilor sale. Nu afectează prețul pe care îl plătești.`)
};

const fi_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luojakoodimme käyttäminen auttaa tukemaan egdata.appin ja sen ominaisuuksien kehitystä. Se ei vaikuta maksamaasi hintaan.`)
};

const sv_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att använda vår skaparkod hjälper till att stödja utvecklingen av egdata.app och dess funktioner. Det påverkar inte priset du betalar.`)
};

const vi_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sử dụng mã sáng tạo của chúng tôi giúp hỗ trợ phát triển egdata.app và các tính năng của nó. Nó không ảnh hưởng đến giá bạn phải trả.`)
};

const tr_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturucu kodumuzu kullanmak, egdata.app'in ve özelliklerinin geliştirilmesine destek olur. Ödediğiniz fiyatı etkilemez.`)
};

const cs_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použití našeho tvůrčího kódu pomáhá podpořit vývoj egdata.app a jeho funkcí. Neovlivní to cenu, kterou zaplatíte.`)
};

const bg_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Използването на нашия създателски код помага за подкрепа на разработката на egdata.app и неговите функции. Не влияе на цената, която плащате.`)
};

const ru_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использование нашего кода создателя помогает поддерживать разработку egdata.app и его функций. Это не влияет на цену игр, которую вы платите.`)
};

const uk_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Використання нашого коду творця допомагає підтримувати розробку egdata.app та його функцій. Це не впливає на ціну, яку ви платите.`)
};

const ar_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدام رمز المنشئ الخاص بنا يساعد في دعم تطوير egdata.app وميزاته. لا يؤثر على السعر الذي تدفعه.`)
};

const hi_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे क्रिएटर कोड का उपयोग करने से egdata.app और इसकी सुविधाओं के विकास में सहायता मिलती है। इससे आपके द्वारा भुगतान की जाने वाली कीमत प्रभावित नहीं होती है।`)
};

const th_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การใช้โค้ดผู้สร้างของเราช่วยสนับสนุนการพัฒนา egdata.app และฟีเจอร์ต่าง ๆ ไม่มีผลต่อราคาที่คุณชำระ`)
};

const ja_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイターコードを使用すると、egdata.app とその機能の開発をサポートできます。お支払い価格には影響しません。`)
};

const zh_cn2_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用我们的创作者代码有助于支持 egdata.app 及其功能的开发，且不会影响您支付的价格。`)
};

const zh_hant1_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用我們的創作者代碼有助於支援 egdata.app 及其功能的開發，且不會影響您支付的價格。`)
};

const ko_store_creatorcode_body1 = /** @type {(inputs: Store_Creatorcode_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이터 코드를 사용하면 egdata.app 및 그 기능 개발을 지원하는 데 도움이 됩니다. 지불하는 가격에는 영향을 미치지 않습니다.`)
};

/**
* | output |
* | --- |
* | "Using our creator code helps support the development of egdata.app and its features. It doesn't affect the price you pay." |
*
* @param {Store_Creatorcode_Body1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const store_creatorcode_body1 = /** @type {((inputs?: Store_Creatorcode_Body1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Creatorcode_Body1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_store_creatorcode_body1(inputs)
	if (locale === "ms") return ms_store_creatorcode_body1(inputs)
	if (locale === "da") return da_store_creatorcode_body1(inputs)
	if (locale === "de") return de_store_creatorcode_body1(inputs)
	if (locale === "en-US") return en_us2_store_creatorcode_body1(inputs)
	if (locale === "es-ES") return es_es2_store_creatorcode_body1(inputs)
	if (locale === "es-MX") return es_mx2_store_creatorcode_body1(inputs)
	if (locale === "fil") return fil_store_creatorcode_body1(inputs)
	if (locale === "fr") return fr_store_creatorcode_body1(inputs)
	if (locale === "it") return it_store_creatorcode_body1(inputs)
	if (locale === "hu") return hu_store_creatorcode_body1(inputs)
	if (locale === "nl") return nl_store_creatorcode_body1(inputs)
	if (locale === "no") return no_store_creatorcode_body1(inputs)
	if (locale === "pl") return pl_store_creatorcode_body1(inputs)
	if (locale === "pt-BR") return pt_br2_store_creatorcode_body1(inputs)
	if (locale === "pt") return pt_store_creatorcode_body1(inputs)
	if (locale === "ro") return ro_store_creatorcode_body1(inputs)
	if (locale === "fi") return fi_store_creatorcode_body1(inputs)
	if (locale === "sv") return sv_store_creatorcode_body1(inputs)
	if (locale === "vi") return vi_store_creatorcode_body1(inputs)
	if (locale === "tr") return tr_store_creatorcode_body1(inputs)
	if (locale === "cs") return cs_store_creatorcode_body1(inputs)
	if (locale === "bg") return bg_store_creatorcode_body1(inputs)
	if (locale === "ru") return ru_store_creatorcode_body1(inputs)
	if (locale === "uk") return uk_store_creatorcode_body1(inputs)
	if (locale === "ar") return ar_store_creatorcode_body1(inputs)
	if (locale === "hi") return hi_store_creatorcode_body1(inputs)
	if (locale === "th") return th_store_creatorcode_body1(inputs)
	if (locale === "ja") return ja_store_creatorcode_body1(inputs)
	if (locale === "zh-CN") return zh_cn2_store_creatorcode_body1(inputs)
	if (locale === "zh-Hant") return zh_hant1_store_creatorcode_body1(inputs)
	return ko_store_creatorcode_body1(inputs)
});
export { store_creatorcode_body1 as "store.creatorCode.body" }